import {
  Box,
  Button,
  HStack,
  Skeleton,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";

const ReusableTable = ({
  columns = [],
  data = [],
  size = "sm",
  variant = "simple",
  emptyText = "No records found",
  loading = false,
  enablePagination = false,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  rowHeight,
  cellPy = "12px",
}) => {
  const hasData = Array.isArray(data) && data.length > 0;
  const canGoPrev = currentPage > 1;
  const canGoNext = currentPage < totalPages;
  const skeletonRows = 5;

  const handlePrevious = () => {
    if (!canGoPrev || !onPageChange) return;
    onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (!canGoNext || !onPageChange) return;
    onPageChange(currentPage + 1);
  };

  return (
    <Box>
      <Box overflowX="auto">
        <Table size={size} variant={variant}>
          <Thead>
            <Tr>
              {columns.map((column) => (
                <Th key={column.key} isNumeric={column.isNumeric}>
                  {column.header}
                </Th>
              ))}
            </Tr>
          </Thead>

          <Tbody>
            {loading ? (
              Array.from({ length: skeletonRows }).map((_, rowIndex) => (
                <Tr h={rowHeight} key={`skeleton-row-${rowIndex}`}>
                  {columns.map((column, columnIndex) => (
                    <Td
                      key={`${column.key || "col"}-${columnIndex}-skeleton`}
                      isNumeric={column.isNumeric}
                      py={cellPy}
                    >
                      <Skeleton height="16px" borderRadius="6px" />
                    </Td>
                  ))}
                </Tr>
              ))
            ) : hasData ? (
              data.map((row, rowIndex) => (
                <Tr
                  h={rowHeight}
                  key={row._id || row.id || row.key || `${rowIndex}-${String(row?.createdAt || '')}`}
                >
                  {columns.map((column) => (
                    <Td
                      key={column.key}
                      isNumeric={column.isNumeric}
                      py={cellPy}
                    >
                      {column.render
                        ? column.render(row, rowIndex)
                        : row[column.key]}
                    </Td>
                  ))}
                </Tr>
              ))
            ) : (
              <Tr>
                <Td
                  colSpan={columns.length || 1}
                  textAlign="center"
                  color="gray.500"
                  py="20px"
                >
                  {emptyText}
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </Box>

      {enablePagination && (
        <HStack justifyContent="flex-end" spacing="10px" mt="12px">
          <Button size="sm" onClick={handlePrevious} isDisabled={!canGoPrev}>
            Previous
          </Button>
          <Text fontSize="sm" color="gray.600">
            Page {currentPage} of {Math.max(totalPages, 1)}
          </Text>
          <Button size="sm" onClick={handleNext} isDisabled={!canGoNext}>
            Next
          </Button>
        </HStack>
      )}
    </Box>
  );
};

export default ReusableTable;
